const D_SYMBOLS = { relative: '%', absolute: '€' }

/**
 * Converts channel specific discount to internal discount
 * @param {Number} discount
 * @param {String} type
 */
const toInternalForm = function (discount, type) {
  if (type === 'sqwizProduct') {
    discount /= 100
  } else if (type === 'informacijaProduct') {
    discount /= 100
  }

  return { discount }
}

export { D_SYMBOLS, toInternalForm }

export default {
  /**
   * Calculates discount for given event
   * @param {Object} event MPE params
   * @param {Object} advertisable Advertisable params
   * @param {Object} campaign Campaign params
   * @returns {Object}
   */
  calculate (event = {}, advertisable = {}, campaign = {}) {
    let price = event.price || advertisable.price || 0

    let discount = event.discount
    if (isNaN(discount)) {
      discount = campaign.discount || advertisable.discount || 0
    }

    // If campaign discount is given && it doesn't match with events discount, prioritize  event's discount
    if (campaign.discount && event.discount && campaign.discount !== event.discount)
      discount = event.discount

    let newPrice = (discount >= 0) ? price * (1 - discount) : price + discount
    return {
      old: price,
      new: parseFloat(newPrice.toFixed(2)),
      discount
    }
  },

  /**
   * Gives discount that should be displayed
   * @param {Number} discount
   * @returns {Object{discount:Number, relative:Boolean}}
   */
  getDiscount (discount = 0, relative = true) {
    let discountSymbol = D_SYMBOLS.relative
    if (discount && typeof discount === 'number') {
      if (discount < 0) {
        // ABS discount
        discountSymbol = D_SYMBOLS.absolute
        discount = parseFloat((discount * -1).toFixed(2))
        relative = false
      } else {
        // Relative discount
        discountSymbol = D_SYMBOLS.relative
        discount = parseFloat((discount * 100).toFixed(2))
        relative = true
      }
    } else {
      discount = 0
    }

    // Default
    return { discount, relative, discountSymbol }
  },

  /**
   * Based on raw discount it determines discount type and then
   * calculates the new price
   * @param {Number} price Given price
   * @param {Number} rawDiscount Given discount
   */
  getDiscountedPrice (price, rawDiscount, ceil = false) {
    if (!price) return price
    let { discount, relative } = this.getDiscount(rawDiscount)
    if (relative) {
      const base = price * (1 - discount / 100) * 100
      if (ceil) {
        return Math.ceil(base) / 100
      }
      return Math.round(base) / 100
    } else {
      return price - discount
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/modules/events/discountCalculator.js